
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Button } from '@/components/ui/button';

interface FormActionsProps {
  editingBadge: any | null;
  onCancel: () => void;
  isSubmitting?: boolean;
}

const FormActions: React.FC<FormActionsProps> = ({ 
  editingBadge, 
  onCancel,
  isSubmitting = false
}) => {
  const { t } = useTranslationUtils();

  return (
    <div className="flex justify-end space-x-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onCancel}
      >
        {t('admin.cancel', 'Cancel')}
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {editingBadge 
          ? t('admin.update', 'Update') 
          : t('admin.create', 'Create')}
      </Button>
    </div>
  );
};

export default FormActions;
